<template>
  <ui-link to="/pickem/all" :class="$style.root">
    <span :class="$style.text">{{ t('allTournaments') }}</span>
    <ui-icon name="chevron-right" :class="$style.icon" />
  </ui-link>
</template>

<i18n lang="yaml">
ru:
  allTournaments: Все турниры
</i18n>

<script lang="ts" setup>
import UiIcon from '~/ui-core/components/icon/index.vue'
import UiLink from '@/components/base/link/index.vue'

defineOptions({ name: 'PickemAllTournamentsLink' })

const { t } = useI18n()
</script>

<style lang="scss" module>
.root {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2em 1.6em;
  border: 1px solid color-get(--root-rgb-control-default-bg);
  border-radius: 0.4em;
  color: color-get(--root-rgb-text-1);
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;

  @include hover-focus {
    border-color: color-get(--root-rgb-bg-card);
    background: color-get(--root-rgb-control-default-bg);
  }
}

.text {
  @include typo-get(label-m);
}

.icon {
  width: 1.6em;
  height: 1.6em;
  color: color-get(--root-rgb-text-2);
}
</style>
